import React from 'react';

/**
 * Pulsing placeholder shown while /api/products loads. Renders the exact same
 * card silhouette as ProductCard so the layout doesn't shift when the real
 * data arrives (no CLS penalty).
 */
export function ProductCardSkeleton() {
  return (
    <div
      className="bg-white rounded-xl border border-slate-200 overflow-hidden flex flex-col animate-pulse"
      data-testid="product-card-skeleton"
    >
      <div className="aspect-square bg-slate-200" />
      <div className="p-3 flex flex-col flex-1 gap-2">
        <div className="h-3 bg-slate-200 rounded w-11/12" />
        <div className="h-3 bg-slate-200 rounded w-7/12" />
        <div className="mt-2 flex items-end justify-between">
          <div className="space-y-1">
            <div className="h-2 bg-slate-200 rounded w-10" />
            <div className="h-5 bg-slate-300 rounded w-16" />
          </div>
          <div className="h-9 w-20 bg-slate-200 rounded-full" />
        </div>
      </div>
    </div>
  );
}

export function ProductGridSkeleton({ count = 8 }) {
  return (
    <div
      className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3"
      data-testid="product-grid-skeleton"
    >
      {Array.from({ length: count }).map((_, i) => <ProductCardSkeleton key={i} />)}
    </div>
  );
}
